/**
 * Partidas
 *
 */
import React from 'react'
import { Table, Divider, Input, InputNumber, Tooltip, Button, message } from 'antd'
import { Cell, Crud } from '../../../components'
import Api from '../../../Api'
import Exception from '../../../Exception'
import _ from 'lodash'
import numeral from 'numeral'

/**
 *
 * @param {number} subContratoId
 * @param {number} estimacionId
 * @param {string} search
 * @returns
 */
function queryPartidas(subContratoId, estimacionId, search) {
  const filter = {}

  if (search && search.length > 0) {
    filter.$or = [
      { descripcion: { $like: `%${search}%`} },
      { wbs: { $like: `%${search}%`} },
    ]
  }

  return Api.query.list({
    maestro: {
      __returnType: 'one',
      model: 'SubEstimacion',
      attributes: [
        'iId',
        'iIdUsuarioSolicita',
        'sStatus',
      ],
      where: { iId: estimacionId },
    },
    conceptos: {
      model: 'CmrConceptoAnexo',
      attributes: [
        'id',
        'wbs',
        'pu_mxn',
        'descripcion',
        'medida',
        'cantidad',
        [
          { literal:'@vol_ampliaciones := fn_cmr_concepto_ampliacion_volumen(CmrConceptoAnexo.id)' },
          'vol_ampliaciones'
        ],
        [
          { literal:'@cantidad_ampliacion := (cantidad + @vol_ampliaciones)' },
          'cantidad_ampliacion'
        ],
        [
          { literal:'cantidadPendienteEstimar + @vol_ampliaciones' },
          'cantidadPendienteEstimar'
        ],

        [
          { literal: '@cantidad_ampliacion * pu_mxn' },
          'importeConcepto'
        ],
      ],
      include: [
         {
            as: 'partidaEstimacion',
            required: false,
            attributes: [
               ['iId', 'id'],
               'dVolumenEstimacion',
               ['dVolumenEstimacion', 'dAnterior'],
               [
                  { literal:'(select sum(dVolumenEstimacion) from sub_estimaciones_partidas where iActivo and iIdPartida = partidaEstimacion.iIdPartida)' },
                  'volumenEstimado'
               ]
            ],
            where: {
               iActivo: true,
               iIdEstimacion: estimacionId,
            }
         }
      ],
      where: {
        $and: [
          { $whereFn: ['fn_cmr_proyecto_escalatoria', [subContratoId], { $eq: '$escalatoria$' }] }
        ],
        medida: {
            $and: [ { $ne:null }, { $ne: '' }]
        },
        activo: true,
        ...filter,
      }
    }
  })
}

/**
 *
 * @param {number} id
 * @param {any} values
 * @returns
 */
function setEstimacionItemValues (id, values) {
  const payload = {
    model: 'SubEstimacionPartida',
    id,
    values,
  }

  return Api.post('/kernel/mutator', payload)
}

/**
 *
 * @param {{ subContratoId: number, estimacionId: number }} props
 * @returns
 */
function ThemedEstimacionPartidasTable(props) {
  const [loading, setLoading] = React.useState(false)
  const [master, setMaster] = React.useState()
  const [records, setRecords] = React.useState([])
  const [searchText, setSearch] = React.useState()
  const masterIsPending = (_.get(master, 'sStatus') === 'PENDIENTE' && _.get(master, 'iIdUsuarioSolicita') === null)

  const renderQuantity = val => numeral(val).format('0,0.00')
  const renderCurrency = val => numeral(val).format('$0,0.00')

  /**
   *
   * @param {string} id
   * @param {string | number} new_val
   */
   const setRecordValue = (id, key, new_val) => {
    setRecords(data => {
      const new_data = data.map(i => {
        if (i.id.toString() !== id) { return i }
        const new_i = JSON.parse(JSON.stringify(i))
        _.set(new_i, key, new_val)
        return new_i
      })

      return new_data
    })
  }

  /**
   *
   * @param {string} target_id
   * @param {number} new_vol
   */
  const onVolChange = (pda_id, target_id, new_vol) => {
    if (loading) { return }
    setLoading(true)

    const payload = {
      dVolumenEstimacion: +new_vol
    }

    if (!target_id) {
      payload.iIdEstimacion = props.estimacionId
      payload.iIdPartida = pda_id
    }

    setEstimacionItemValues(target_id, payload)
      .then(res => {
        setRecords(data => {
          const new_data = data.map(i => {
            if (i.id.toString() !== pda_id.toString()) { return i }
            const new_i = JSON.parse(JSON.stringify(i))
            _.set(new_i, 'partidaEstimacion.dAnterior', new_vol)

            if (!target_id) {
              _.set(new_i, 'partidaEstimacion.id', res.data.record.iId)
            }

            return new_i
          })

          return new_data
        })
        setLoading(false)
      })
      .catch(e => {
        setLoading(false)
        Exception.load(e).show()
      })
  }

  /**
   * remove
   *
   * @param {number} id
   */
  const remove = (id) => {
    if (loading || (!id)) { return }
    setLoading(true)

    const payload = {
      id,
      model: 'SubEstimacionPartida',
      values: { iActivo: false }
    }

    Api.post(`/kernel/mutator`, payload)
      .then(() => {
        message.success('Eliminado')
        setRecords(data => {
          const new_data = data.map(i => {
            if (_.get(i, 'partidaEstimacion.id', '').toString() !== id.toString()) { return i }
            const new_i = JSON.parse(JSON.stringify(i))
            _.set(new_i, 'partidaEstimacion', undefined)
            return new_i
          })

          return new_data
        })

        setLoading(false)
      })
      .catch(error => {
        setLoading(false)
        Exception.load(error).show()
      })
  }

  /**
   *
   * @param {string} search
   */
   const fetch = (search) => {
    setLoading(true)
    queryPartidas(props.subContratoId, props.estimacionId, search)
      .then(res => {
        setLoading(false)
        setMaster(res.data.maestro)
        setRecords(res.data.conceptos)
        setSearch(search)
      })
      .catch(e => {
        setLoading(false)
        Exception.load(e).show()
      })
  }

  /**
   * columns
   */
  const columns = Cell.buildList([
    { title: 'PARTIDA', dataIndex: 'wbs', width: '5%' },
    { title: 'DESCRIPCIÓN', dataIndex: 'descripcion', width: '30%' },
    { title: 'U.M.', dataIndex: 'medida', width: '5%' },
    { title: 'P.U. (PARTIDA)', className: 'column-money', dataIndex: 'pu_mxn', render: renderCurrency, width: '7%' },
    { title: 'VOLUMEN CONTRACTUAL', dataIndex: 'cantidad_ampliacion', width: '7%' },
    { title: 'VOLUMEN ESTIMADO', dataIndex: 'partidaEstimacion.volumenEstimado', width: '7%' },
    { title: 'VOL. PENDIENTE ESTIMAR', dataIndex: 'cantidadPendienteEstimar', width: '7%', render: renderQuantity, },
    { title: 'IMPORTE (PARTIDA)', className: 'column-money', dataIndex: 'importeConcepto', render: renderCurrency, width: '7%' },
    { title: 'VOLUMEN ESTA ESTIMACIÓN', dataIndex: 'partidaEstimacion.dVolumenEstimacion', width: '7%', render: !masterIsPending ? renderQuantity : (val, r) => (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <InputNumber
          value={val}
          defaultValue={val}
          disabled={!masterIsPending}
          onChange={new_val => setRecordValue(r.id.toString(), 'partidaEstimacion.dVolumenEstimacion', new_val)}
          min={0}
        />

        <Tooltip title='Guardar'>
          <Button
            icon='check'
            size='small'
            loading={loading}
            onClick={() => onVolChange(r.id, _.get(r, 'partidaEstimacion.id'), val)}
            disabled={(!masterIsPending) || loading || (!r.partidaEstimacion) || (+_.get(r, 'partidaEstimacion.dVolumenEstimacion')) === (+_.get(r, 'partidaEstimacion.dAnterior'))}
            style={{ marginLeft: 5, marginRight: 5 }}
          />
        </Tooltip>

        {!r.partidaEstimacion ? null : (
          <Tooltip title='Quitar'>
            <Button
              icon='delete'
              size='small'
              loading={loading}
              onClick={() => remove(_.get(r, 'partidaEstimacion.id'))}
              disabled={(!masterIsPending) || loading}
              style={{ marginLeft: 5, marginRight: 5 }}
            />
          </Tooltip>
        )}
      </div>
    )},
    { title: 'IMPORTE ESTA ESTIMACIÓN', className: 'column-money', dataIndex: 'partidaEstimacion.dVolumenEstimacion', width: '7%',
      render: (val, r) => renderCurrency(val * r.pu_mxn)
    },
  ])

  /**
   * onLoad
   *
   */
  React.useEffect(() => {
    fetch()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.subContratoId, props.estimacionId])

  const crud = (
    <Crud
      buttons={['reload']}
      onReload={() => fetch(searchText)}
    />
  )

  const tableTitle = (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      {crud}
      <Divider type='vertical'/>
      <Input.Search
        placeholder='Buscar'
        style={{ width: 185 }}
        onSearch={value => fetch(value)}
        allowClear
      />
    </div>
  )

  return (
    <Table
      rowKey='id'
      size='small'
      rowClassName='row-pure'
      pagination={false}
      bordered={true}
      dataSource={records}
      columns={columns}
      loading={loading}
      title={() => tableTitle}
    />
  )
}

/**
 *
 * @param {{ estimacionId: number, subContratoId: number }} props
 */
export function EstimacionPartidas(props) {
  return (
    <ThemedEstimacionPartidasTable
      subContratoId={props.subContratoId}
      estimacionId={props.estimacionId}
    />
  )
}


export const EstimacionPartidasTable = ThemedEstimacionPartidasTable
